import script from "./SubmitProviderData.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmitProviderData.vue?vue&type=script&setup=true&lang=js"

import "./SubmitProviderData.vue?vue&type=style&index=0&id=6176345e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6176345e"]])

export default __exports__